import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContextService } from '../core/context/context.service';

// RxJS
import { throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';



@Component({
	selector: 'pgs-performance',
	template: ''
})
export class PerformanceComponent implements OnInit {

	constructor(private httpClient: HttpClient,
              private route: ActivatedRoute,
		          private contextService: ContextService) { }

	ngOnInit() {
		this.route.queryParamMap.pipe(
      switchMap(params => {
        const method = params.get('method');
        const url = params.get('url');
        const body = params.get('body');
        const tenant = params.get('tenant') || 'CL';
        this.contextService.changeCountry(tenant);
        if (!url) {
          return throwError('error');
        }
        switch (method) {
          case 'POST': return this.httpClient.post(url, body);
          case 'PUT': return this.httpClient.put(url, body);
          case 'DELETE': return this.httpClient.delete(url);
          default: return this.httpClient.get(url);
        }
      })
    ).subscribe(
			() => {},
			err => { console.log('Error: '); console.log(err); }
		);
	}
}
